
export const styles = {
  
  row: {
    backgroundColor: '#eeeeee',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: '20px',
    width: '95%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'space-between',
    justifyContent: 'space-between',
    fontWeight: 'normal',
    color: '#oooooo',
    padding: 8,
  },
  
  date: {
    backgroundPosition: 'center',
    height: '20px',
    width: '60%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'space-between',
    justifyContent: 'space-between',
    fontWeight: 'normal',
    color: '#oooooo',
    padding: 8,
    margin: '0 50px 50px 50px',

  },
  
  card: {
    padding: '10px 5px',
    margin: '10px 15px',
    borderRadius: '10px',
    width: '75%',
    backgroundColor: '#eeeeee',
    flexDirection: 'column',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    display: 'flex',
  },
  
  paymentType: {
    fontSize: '24px',
    borderRadius: '10px',
    backgroundColor: '#3689ea',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    padding: 10,
    width: '77%',
    height: '35px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'space-between',
    justifyContent: 'space-between',
    fontWeight: 'bold',
    color: '#ffffff',
    margin: 0,
  },

  Container: {
    padding: '20px',
    width: '95%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'left',
    justifyContent: 'center',
  },

  TextContainer: {
    borderRadius: '5px',
    backgroundColor: '#474747',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    padding: '30px 30px',
    width: '50%',
    height: '50px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 0,
  },
    
  WithoutTransactionsMessage: {
    fontWeight: 'bold',
    color: '#ffffff',
    fontSize: '30px',
  },
  
  button: {
    padding: 5,
    margin: 5,
    borderRadius: 5,
    backgroundColor: '#3689ea',
    color: '#ffffff',
    fontWeight: 'bold',
    minWidth: 250,
  },
};

export default styles;
